// Generated by purs version 0.13.8
"use strict";
var otherwise = true;
module.exports = {
    otherwise: otherwise
};
